export var FileType;
(function (FileType) {
    FileType["CSV"] = "text/csv";
    FileType["XLS"] = "application/vnd.ms-excel";
    FileType["XLSX"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    FileType["PDF"] = "application/pdf";
    FileType["JPEG"] = "image/jpeg";
    FileType["PNG"] = "image/png";
    FileType["TIFF"] = "image/tiff";
    FileType["ZIP"] = "application/zip";
    FileType["CSV_EXTENSION"] = "csv";
    FileType["XLS_EXTENSION"] = "xls";
    FileType["XLSX_EXTENSION"] = "xlsx";
    FileType["PDF_EXTENSION"] = "pdf";
})(FileType || (FileType = {}));
export const filetypeMapper = {
    jpg: FileType.JPEG,
    jpeg: FileType.JPEG,
    png: FileType.PNG,
    pdf: FileType.PDF,
    tif: FileType.TIFF,
    tiff: FileType.TIFF,
    csv: FileType.CSV,
    xls: FileType.XLS,
    XLSX: FileType.XLSX,
    zip: FileType.ZIP,
};
